import './Loader.scss';

const Loader = ({ white, small, abs }) => {
  let classes = 'circle';
  let loaderClasses = 'loader';

  if (white) {
    classes += ' white';
  }

  if (small) {
    classes += ' small';
  }

  if (abs) {
    loaderClasses += ' abs';
  }

  return (
    <div className={small ? `${loaderClasses} small` : `${loaderClasses}`}>
      <div className={classes}></div>
      <div className={classes}></div>
      <div className={classes}></div>
    </div>
  );
};

export default Loader;
